const myPlugin = {
  install(app) {
    app.config.globalProperties.$convertToDate = (dateString) => {
      if (typeof dateString === "undefined") {
        return " - ";
      }
      let date = new Date(dateString);
      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      let hours = date.getHours();
      let minutes = date.getMinutes().toString().padStart(2, "0");
      return `${day}.${month}.${year} ${hours}:${minutes}`;
    };
    app.config.globalProperties.$convertUTCDateToLocalDate = (date) => {
      // If input is an explicit UTC string (ends with Z or has +HH:MM offset),
      // extract UTC components and treat them as the intended local time.
      // This handles dates returned from the server with timezone info.
      if (
        typeof date === "string" &&
        (date.endsWith("Z") || /[+-]\d{2}:\d{2}$/.test(date))
      ) {
        const utc = new Date(date);
        const localStr =
          `${utc.getUTCFullYear()}-` +
          `${String(utc.getUTCMonth() + 1).padStart(2, "0")}-` +
          `${String(utc.getUTCDate()).padStart(2, "0")}T` +
          `${String(utc.getUTCHours()).padStart(2, "0")}:` +
          `${String(utc.getUTCMinutes()).padStart(2, "0")}:` +
          `${String(utc.getUTCSeconds()).padStart(2, "0")}`;
        const d = new Date(localStr); // parsed as local
        return new Date(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
      }

      // Input is a Date object, new Date(), or a naive string without timezone.
      // Browser parses naive strings as local time, so just apply offset shift.
      const d = new Date(date);
      return new Date(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
    };
    app.config.globalProperties.$formatDateTimeWithTimeZone = (date) => {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const hour = String(d.getHours()).padStart(2, "0");
      const minute = String(d.getMinutes()).padStart(2, "0");
      const second = String(d.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day}T${hour}:${minute}:${second}`;
    };
    app.config.globalProperties.$convertStringToNumber = (str) => {
      // Handle numbers directly (no conversion needed)
      if (typeof str === "number") {
        return str;
      }

      if (typeof str === "string") {
        const numericPart = str.match(/\d+/);
        return numericPart ? parseInt(numericPart[0], 10) : NaN;
      }

      // Handle objects (e.g. Vue Proxy of API resource with id or @id)
      if (str && typeof str === "object") {
        if (typeof str.id === "number") return str.id;
        if (str["@id"] && typeof str["@id"] === "string") {
          const numericPart = str["@id"].match(/\d+/);
          return numericPart ? parseInt(numericPart[0], 10) : NaN;
        }
      }

      // null/undefined - silently return NaN (caller should guard against this)
      if (str == null) {
        return NaN;
      }

      console.error(
        "$convertStringToNumber: Invalid input. Expected a string or number.",
        str,
      );
      return NaN;
    };
    // ApiPlatform serializes a relation as an IRI string ("/api/languages/2")
    // OR, when the related entity also exposes properties in the same
    // serialization group (e.g. Language.id/name/isocode in 'TextContent:read'),
    // as a fully embedded object ({ "@id": "/api/languages/2", id, name, ... }).
    // Use this whenever comparing a relation field against an IRI string,
    // otherwise object === string comparisons silently always fail.
    app.config.globalProperties.$getIri = (value) => {
      if (value && typeof value === "object") {
        return value["@id"] ?? null;
      }
      return value ?? null;
    };
    app.config.globalProperties.$isValidEmail = (email) => {
      if (!email || email.trim() === "") {
        return false; // Prazan email
      }

      // Samo ASCII karakteri, domeni mogu biti duži od 4 slova
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test(email);
    };
    app.config.globalProperties.$calculateInnerArrayLengths = (arr) => {
      const lengths = [];

      for (const proxyArray of arr) {
        const innerArrayLength = proxyArray.length;
        lengths.push(innerArrayLength);
      }

      return lengths;
    };
    app.config.globalProperties.$dateTimeFormat = (param) => {
      let date = new Date(param);

      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      let hours = date.getHours();
      let minutes = date.getMinutes().toString().padStart(2, "0");
      return `${day}.${month}.${year} ${hours}:${minutes}`;
    };
    app.config.globalProperties.$encodeEmail = (email) => {
      const [username, domain] = email.split("@");

      const encodedUsername = encodeURIComponent(username).replace(
        /\+/g,
        "%2B",
      );

      const encodedDomain = encodeURIComponent(domain);

      const encodedEmail = `${encodedUsername}%40${encodedDomain}`;

      return encodedEmail;
    };

    /* Is ASCII */

    app.config.globalProperties.$isAscii = (str) => {
      // eslint-disable-next-line no-control-regex -- full ASCII range is intended
      return /^[\x00-\x7F]*$/.test(str);
    };
    app.config.globalProperties.$preventNonAscii = function (event) {
      if (!this.$isAscii(event.key)) {
        event.preventDefault();
      }
    };

    /* Table filters functions */

    app.config.globalProperties.$filterConditions = (
      filter,
      columnName,
      queryParams,
    ) => {
      if (filter.constraints) {
        const [constraint1, constraint2] = filter.constraints;

        const formatDateForQuery = (date) => {
          let newDate = new Date(date);

          let day = newDate.getDate();
          let month = newDate.getMonth() + 1;
          let year = newDate.getFullYear();

          day = day < 10 ? `0${day}` : day;
          month = month < 10 ? `0${month}` : month;

          let formattedDate = `${day}-${month}-${year}`;

          return formattedDate;
        };

        // Funkcija za dodavanje vrednosti u query params (radi sa nizovima)
        const addToQueryParams = (key, value) => {
          if (queryParams[key]) {
            // Ako već postoji, konvertuj u niz
            if (Array.isArray(queryParams[key])) {
              queryParams[key].push(value);
            } else {
              queryParams[key] = [queryParams[key], value];
            }
          } else {
            queryParams[key] = value;
          }
        };

        // Procesiranje constraint-a
        const processConstraint = (constraint) => {
          if (!constraint || !constraint.value) return;

          switch (constraint.matchMode) {
            case "startsWith":
              addToQueryParams(`${columnName}[start]`, constraint.value);
              break;
            case "endsWith":
              addToQueryParams(`${columnName}[end]`, constraint.value);
              break;
            case "contains":
              addToQueryParams(`${columnName}[partial]`, constraint.value);
              break;
            case "equals": {
              const exactValue = constraint.value.id || constraint.value;
              // Za products koristimo array format umesto [exact]
              if (columnName === "products") {
                addToQueryParams(`${columnName}[]`, exactValue);
              } else {
                addToQueryParams(`${columnName}[exact]`, exactValue);
              }
              break;
            }
            case "dateBefore":
              addToQueryParams(
                `${columnName}[before]`,
                formatDateForQuery(constraint.value),
              );
              break;
            case "dateAfter":
              addToQueryParams(
                `${columnName}[after]`,
                formatDateForQuery(constraint.value),
              );
              break;
          }
        };

        // Procesiranje oba constraint-a
        processConstraint(constraint1);
        if (constraint2) {
          processConstraint(constraint2);
        }

        // Dodavanje order type ako postoji
        if (filter.orderType === "asc" || filter.orderType === "desc") {
          queryParams[`order[${columnName}]`] = filter.orderType;
        }
      } else if (
        filter.value &&
        Array.isArray(filter.value) &&
        filter.value.length > 0
      ) {
        // Procesiranje niza vrednosti (npr. za multi-select filtere)
        filter.value.forEach((v) => {
          let exactValue;
          if (v.user && v.user.id) {
            exactValue = v.user.id;
          } else if (v && v.id) {
            exactValue = v.id;
          } else {
            exactValue = v;
          }

          // Za products i projectManagers.user koristimo array format umesto [exact]
          const key =
            columnName === "products" || columnName === "projectManagers.user"
              ? `${columnName}[]`
              : `${columnName}[exact]`;

          if (queryParams[key]) {
            if (Array.isArray(queryParams[key])) {
              queryParams[key].push(exactValue);
            } else {
              queryParams[key] = [queryParams[key], exactValue];
            }
          } else {
            queryParams[key] = exactValue;
          }
        });
      } else if (filter.orderType === "asc" || filter.orderType === "desc") {
        // Samo order type bez constraint-a
        queryParams[`order[${columnName}]`] = filter.orderType;
      }
    };
  },
};

export default myPlugin;
